import { padLeft } from "../../../../javascript-utils/string/index.js";
import { SEPARATOR_CHARACTER } from "./const.js";
function parseDurationHHMM(rawDisplayValue) {
  if (rawDisplayValue.length === 0) return null;
  if (rawDisplayValue.length > 5) return "invalidFormat";
  const displayValue = rawDisplayValue.includes(SEPARATOR_CHARACTER) ? rawDisplayValue : padLeft(rawDisplayValue, 4, "0");
  const regexBody = `^(?<hh>[0-9][0-9]?)(${SEPARATOR_CHARACTER}?(?<mm>[0-9]|[0-5][0-9])?)?$`;
  const regex = new RegExp(regexBody);
  const regRes = regex.exec(displayValue);
  if (regRes === null || regRes.groups === void 0) {
    return "invalidFormat";
  }
  return Number(regRes.groups.hh ?? 0) * 3600 + Number(regRes.groups.mm ?? 0) * 60;
}
export {
  parseDurationHHMM
};
//# sourceMappingURL=parseDurationHHMM.js.map
